module.exports = __webpack_public_path__ + "img/lms-dashboard-student-background.5da02ff0.svg";